import { render, staticRenderFns } from "./SeatWhisper.vue?vue&type=template&id=0f000a08"
import script from "./SeatWhisper.vue?vue&type=script&lang=js"
export * from "./SeatWhisper.vue?vue&type=script&lang=js"
import style0 from "./SeatWhisper.vue?vue&type=style&index=0&id=0f000a08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports